import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { oauthApplicationsAccessControl } from '../access-control/oauthApplicationsAccess.configuration'

const OauthApplicationsListPage = lazy(() => import('../pages/list/OauthApplicationsListPage'))
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const oauthApplicationsRouter = (
  <DomainRoute route="oauth-applications" accessControl={oauthApplicationsAccessControl}>
    <DashSwitch>
      <DomainRoute exact route="oauth-applications-list" component={OauthApplicationsListPage} />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
